import React, { ReactElement } from 'react';
import { ResponseMission } from '../../../../services/api/models/response/responseMission';
import './MissionTabItem.scss';

interface MissionItemProps {
  mission: ResponseMission;
  onReceiveBtnClick?: () => void;
}

export const MissionTabItem = (props: MissionItemProps): ReactElement => {
  const { mission, onReceiveBtnClick } = props;

  const getPercent = (): string => {
    const percent = Math.round(
      (mission.measuredValue / mission.targetValue) * 100,
    );
    return `${percent}%`;
  };

  const getButtonStyle = (): React.CSSProperties => {
    if (
      mission.measuredValue === mission.targetValue &&
      !mission.receivedDateTime
    ) {
      return {
        backgroundColor: '#ff64de',
        cursor: 'pointer',
      };
    } else {
      return {
        backgroundColor: '#c0c0c0',
        pointerEvents: 'none',
      };
    }
  };

  const handleReceiveBtnClick = () => {
    if (
      mission.measuredValue === mission.targetValue &&
      !mission.receivedDateTime &&
      onReceiveBtnClick
    ) {
      onReceiveBtnClick();
    }
  };

  return (
    <div className="mission-tab-item-root">
      <div className="mission-tab-item">
        <div className="mission-tab-item__thumbnail">
          <img src={mission.prizeResourceUri} />
        </div>
        <div className="mission-tab-item__info">
          <p className="mission-tab-item__info__title">{mission.title}</p>
          <p className="mission-tab-item__info__desc">{mission.description}</p>
        </div>
      </div>
      <div className="mission-tab-item-progress">
        <div className="mission-tab-item-progress-bar">
          <div
            className="mission-tab-item-progress-indicator"
            style={{ width: getPercent() }}
          ></div>
          <div className="mission-tab-item-progress-text">
            {`${mission.measuredValue}/${mission.targetValue}`}
          </div>
        </div>
        <div className="mission-tab-item-progress__action">
          <div
            className="mission-tab-item-progress__button"
            style={getButtonStyle()}
            onClick={handleReceiveBtnClick}
          >
            {mission.receivedDateTime ? '受け取り済み' : '受け取る'}
          </div>
        </div>
      </div>
    </div>
  );
};
